// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-Admin-__AdminPage-module___Main"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Admin/AdminPage.module.css
// module id = 1177
// module chunks = 1